export default __webpack_public_path__ + "static/Expanding-your-horizons-f3d0fad16b81c353472ae77d797ef414.webp";